import FaIcon from 'frontend/components/fa-icon';
<template>
  <span class="loading-spinner">
    <FaIcon @icon="spinner" @spin={{true}} />
  </span>
</template>
